import { render } from "./RepoList.vue?vue&type=template&id=5ee8f9c7&scoped=true"
import script from "./RepoList.vue?vue&type=script&lang=js"
export * from "./RepoList.vue?vue&type=script&lang=js"

import "./RepoList.vue?vue&type=style&index=0&id=5ee8f9c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8f9c7"]])

export default __exports__